import { render, staticRenderFns } from "./PalavrasDiretorExecutivo.vue?vue&type=template&id=c270c060&scoped=true&"
import script from "./PalavrasDiretorExecutivo.vue?vue&type=script&lang=js&"
export * from "./PalavrasDiretorExecutivo.vue?vue&type=script&lang=js&"
import style0 from "./PalavrasDiretorExecutivo.vue?vue&type=style&index=0&id=c270c060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c270c060",
  null
  
)

export default component.exports